export default {
  list: { lazy: () => import('./FinanceValidationSets'), component: 'FinanceValidationSetsList' },
  create: { lazy: () => import('./FinanceValidationSets'), component: 'FinanceValidationSetsCreate' },
  edit: { lazy: () => import('./FinanceValidationSets'), component: 'FinanceValidationSetsEdit' },
}
